import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";
import {
  namKazhagamPolicies,
  NamKazhagamPolicy,
} from "./namKazhagamPolicies";
import "../styles/NamKazhagamLegal.scss";

const NamKazhagamLegal = ({ policy }: { policy: NamKazhagamPolicy }) => {
  const document = namKazhagamPolicies[policy];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [policy]);

  return (
    <div className="nam-kazhagam-legal" lang="en">
      <Helmet>
        <title>{document.title} | Nam Kazhagam | The PEN India</title>
        <meta
          name="description"
          content={`${document.title} for the Nam Kazhagam membership and organisation-management app by Populus Empowerment Network (PEN).`}
        />
        <link
          rel="canonical"
          href={`https://www.thepenindia.com${document.path}`}
        />
      </Helmet>

      <a className="nk-skip-link" href="#nk-content">Skip to policy content</a>
      <header className="nk-header">
        <a className="nk-brand" href="/">The PEN India</a>
        <span>Nam Kazhagam</span>
      </header>

      <main id="nk-content" className="nk-content" tabIndex={-1}>
        <p className="nk-eyebrow">Nam Kazhagam / Legal</p>
        <h1>{document.title}</h1>
        <p className="nk-intro">
          Nam Kazhagam is a Tamil Nadu party membership and organisation-management
          app, presented as a product of The PEN India.
        </p>

        <nav className="nk-contents" aria-label="On this page">
          <h2>On this page</h2>
          <ol>
            {document.sections.map((section) => (
              <li key={section.id}>
                <a href={`#${section.id}`}>{section.title}</a>
              </li>
            ))}
          </ol>
        </nav>

        <article aria-label={document.title}>
          {document.sections.map((section, index) => (
            <section key={section.id} id={section.id} className="nk-section">
              <h2>{index + 1}. {section.title}</h2>
              {section.content}
            </section>
          ))}
        </article>
      </main>

      <footer className="nk-footer">
        <p>Nam Kazhagam - a product of The PEN India</p>
        <nav aria-label="Legal footer">
          <a href="/">The PEN India home</a>
          {Object.values(namKazhagamPolicies).map((item) => (
            <NavLink key={item.path} to={item.path}>{item.title}</NavLink>
          ))}
        </nav>
      </footer>
    </div>
  );
};

export default NamKazhagamLegal;
